import React from 'react'
import AboutPage from '../Pages/AboutPage'

export default function About() {
  return (
    <section id="about" className="section about">
      <h2 className="section-title only-on-mobile">About</h2>
      <div className="section-content">
        <AboutPage />
      </div>
    </section>
  )
}


